import DeliveryInformation from "./DeliveryInformation";

export default DeliveryInformation;
